import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

import { Loading } from "../../../../_metronic/elements/Loading";
import { useErrorHandler } from "../../../../_metronic/helpers/ErrorHandler";
import { formatNumber } from "../../../shared/numberFormat";
import * as UserService from "../services/UserService";



const PaymentInformation = () => {
  const { t } = useTranslation();
  const names = {
    'ambients': t("payments:view.names.ambients"),
    'members': t("payments:view.names.users"),
    "reports_ndvi_ha": t("payments:view.names.reports_ndvi"),
    "planet_hd_ha": t("payments:view.names.planet_hd")
  };
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const { errorHandler } = useErrorHandler();
  const load = async () => {
    setLoading(true);
    const res = await errorHandler(UserService.currentPlan());

    if (res.ok) {
      setData(res.data.data);
    }

    setLoading(false);
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <section className="specific-account-panel">
        <div className="specific-account-panel__header">
          <div>
            <h3 className="specific-account-panel__title">{t("payments:view.title")}</h3>
          </div>
        </div>
        {loading || data == null ? (
          <div className="specific-account-panel__loading">
            <Loading />
          </div>
        ) : (
          <div className="specific-account-plan-grid">
            {data.resources.filter(e => names[e.resource_id]).map(resource => {
              return (
                <div className="specific-account-plan-item" key={resource.resource_id}>
                  <span className="specific-account-plan-item__label">{names[resource.resource_id]}</span>
                  <strong className="specific-account-plan-item__value">{formatNumber(resource.quantity)}</strong>
                </div>
              );
            })}
          </div>
        )}
    </section>
  );
};

export default PaymentInformation;
